import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m5.4 3.212-.286.03a2.84 2.84 0 0 0-2.518 2.466l-.002.017c-.166 1.33-.344 2.762-.344 4.235s.178 2.905.344 4.236l.002.017a2.84 2.84 0 0 0 2.518 2.466l.286.03c1.456.152 3.007.315 4.6.315s3.144-.163 4.6-.315l.286-.03a2.84 2.84 0 0 0 2.518-2.466l.002-.017c.166-1.331.344-2.762.344-4.236s-.178-2.904-.344-4.235l-.002-.017a2.84 2.84 0 0 0-2.518-2.467l-.286-.03c-1.456-.152-3.007-.314-4.6-.314s-3.144.162-4.6.315m-.13 1.521.268-.028c1.472-.153 2.95-.308 4.462-.308s2.99.155 4.461.308l.27.028a1.34 1.34 0 0 1 1.045.713L10.774 9.39a1.25 1.25 0 0 1-1.548 0L4.224 5.446a1.34 1.34 0 0 1 1.045-.713M3.935 7.13c-.106.938-.186 1.878-.186 2.831 0 1.372.166 2.718.334 4.067a1.34 1.34 0 0 0 1.185 1.16l.27.028c1.47.154 2.95.309 4.461.309s2.99-.155 4.461-.309l.27-.028a1.34 1.34 0 0 0 1.185-1.16c.168-1.349.334-2.695.334-4.067 0-.953-.08-1.893-.186-2.83l-4.361 3.438a2.75 2.75 0 0 1-3.406 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMail;
